import type { GetStaticPaths, GetStaticProps, NextPage } from "next"
import { useRouter } from "next/router"
import { brand } from "~/brand"
import { Home } from "~/landing/canyouunlock.com/Home"
import { HowItWorks } from "~/landing/canyouunlock.com/HowItWorks"

const brandLandingPages = {
  "canyouunlock.com": new Map([
    ["", Home],
    ["how-it-works", HowItWorks],
  ]),
}

export const getStaticPaths: GetStaticPaths = () => {
  const paths = []
  for (const landingPage of brandLandingPages[brand.id].keys()) {
    paths.push({
      params: {
        landingPage: landingPage ? [landingPage] : [],
      },
    })
  }

  return {
    paths,
    fallback: false,
  }
}

export const getStaticProps: GetStaticProps = async () => ({ props: {} })

const LandingPage: NextPage = () => {
  const params = useRouter().query.landingPage
  const landingPage = params ? params[0] : ""

  const Page = brandLandingPages[brand.id].get(landingPage)

  if (!Page) return null // Shouldn't happen
  return <Page />
}

export default LandingPage
